import { onMounted, ref, type Ref } from 'vue';
import type { DeviceType } from './types';
import { getDeviceType } from '../lib/getDeviceType';

export function useDeviceType(): Readonly<Ref<DeviceType | null>> {
  const deviceType = ref<DeviceType | null>(null);

  onMounted(() => {
    deviceType.value = getDeviceType();
  });

  return deviceType;
}
